// extracted by mini-css-extract-plugin
export default {"deemos":"story_deemos__0qaoj","continueBtn":"story_continueBtn__geyku","flashAnimation":"story_flashAnimation__tRprC","flashBackground":"story_flashBackground__YHuuM"};